module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDBAMAAACYZb3pAAAAFVBMVEUAcsY9vVgAcsYetTqbyOmo4rP///8qsuxKAAAAAnRSTlPU/snCEjgAAAA3SURBVEjH7csxAQAgEMSws4AFLGABC1jAv4TX0PmaPVlYDmaxWErLw/Ixi8VSWi6WjVksltLCDWuaIGB4ezEiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/sl.png
// module id = kRhZ
// module chunks = 0